import { render } from "./vcurriculumclassifyadd.vue?vue&type=template&id=d6380e5a&scoped=true"
import script from "./vcurriculumclassifyadd.vue?vue&type=script&lang=js"
export * from "./vcurriculumclassifyadd.vue?vue&type=script&lang=js"

import "./vcurriculumclassifyadd.vue?vue&type=style&index=0&id=d6380e5a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6380e5a"]])

export default __exports__